import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  school_levels: [],
  school_level: null
}

// mutations
export const mutations = {
  [types.SET_SCHOOL_LEVELS] (state, school_levels) {
    state.school_levels = school_levels
  },
  [types.SET_SCHOOL_LEVEL] (state, school_level) {
    state.school_level = school_level
  },
  [types.FETCH_SCHOOL_LEVEL_FAILURE] (state) {
    state.school_level = null
  }
}

// actions
export const actions = {
  async fetchSchoolLevels ({ commit }) {
    try {
      const { data } = await axios.get('/api/school_levels')
      commit(types.SET_SCHOOL_LEVELS, data)
    } catch (e) {
      console.log(e)
    }
  },
  async fetchSchoolLevel ({ commit }, school_level) {
    try {
      const { data } = await axios.get(`/api/school_levels/${school_level.id}`)

      commit(types.SET_SCHOOL_LEVEL, { school_level: data })
    } catch (e) {
      commit(types.FETCH_SCHOOL_LEVEL_FAILURE)
    }
  },

  async createSchoolLevel (context, school_level) {
    try {
      await axios.post('/api/school_levels', school_level)
      context.dispatch('fetchSchoolLevels')
    } catch (e) {
      console.log(e)
    }
  },

  async updateSchoolLevel (context, school_level) {
    try {
      await axios.put(`/api/school_levels/${school_level.id}`, school_level)
      context.dispatch('fetchSchoolLevels')
    } catch (e) { }
  },

  async deleteSchoolLevel (context, school_level) {
    try {
      await axios.delete(`/api/school_levels/${school_level.id}`)
      context.dispatch('fetchSchoolLevels')
    } catch (e) { }
  }
}

// getters
export const getters = {
  school_levels: state => state.school_levels
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/school-level.js